import React, { Dispatch, SetStateAction, useState } from "react";

interface Props {
  id: string;
  title: string;
  children: DropdownInterface[];
  subChildren?: SubDropdownInterface[];
  className: string;
  allCaps?: boolean;
  found?: Dispatch<SetStateAction<FoundSubChildrenInterface | undefined>>;
  isSubChild?: boolean;
  onChange?: React.ChangeEventHandler<HTMLSelectElement> | undefined;
  onClick?: React.MouseEventHandler<HTMLOptionElement> | undefined;
}

export interface DropdownInterface {
  id: number;
  value: string;
  text: string;
}

export interface SubDropdownInterface {
  parentValue: string;
  children: DropdownInterface[];
}

export interface FoundSubChildrenInterface {
  found: boolean,
  children?: DropdownInterface[];
}

export const dropdownCss =
  "w-full mb-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-black hover:bg-gray-50";


const Dropdown = React.forwardRef<HTMLSelectElement, Props>(
  ({ id, title, children, className, allCaps, onChange, onClick }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(title);

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleSelect = (version: string) => {
      setSelectedValue(version);
      setIsOpen(false);
    };

    return (
      <div className="relative inline-block text-left">
        {/* Dropdown button */}
        <select
          id={id}
          className={className}
          title={selectedValue}
          onClick={toggleDropdown}
          onChange={onChange}
          ref={ref}
        >
          {children?.map((option, index) => (
            <option
              key={index}
              value={option.value}
              className="block px-4 py-2
                  text-sm text-black
                  hover:bg-gray-100"
              onClick={onClick}
            // selected={props.defaultSelectedPosition == index}
            >
              {option != undefined ? (allCaps != undefined && allCaps === true ? option.text.toUpperCase() : option.text) : "Undefined"}
            </option>
          ))}

          {children.length <= 0 && (
            <option
              value={""}
              className="block px-4 py-2
                  text-sm text-black
                  hover:bg-gray-100"
              onClick={() => {
                handleSelect("");
              }}
            >
              No option available
            </option>
          )}
        </select>
      </div>
    );
  }
);
Dropdown.displayName = "Dropdown";

export default Dropdown;
